import { styled } from '@mui/system';

export const Icon = styled('div')({
  margin: '6px 0 0 -5px'
});

export const CardsCnt = styled('section')({
  textAlign: 'center'
});

export const ShowMoreContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

export const StepProgressBarCnt = styled('div')({
  marginTop: '24px'
});
